module.exports = __webpack_public_path__ + "img/rm.d63b6b82.svg";